export const iconFontAwesomeLogisticsTrain = (
	<i className="fa-solid fa-train"></i>
);
